import { render, staticRenderFns } from "./ProjectCriteria.vue?vue&type=template&id=de86970a&scoped=true"
import script from "./ProjectCriteria.vue?vue&type=script&lang=js"
export * from "./ProjectCriteria.vue?vue&type=script&lang=js"
import style0 from "./ProjectCriteria.vue?vue&type=style&index=0&id=de86970a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de86970a",
  null
  
)

export default component.exports